import { ColDef } from "ag-grid-community";
import { SchemaField } from "types/schema";

export const buildColDef = (productSchema: SchemaField): ColDef => {
    const colDef: ColDef = {
        headerName: productSchema.name,
        colId: productSchema.key,
        hide: true,
        valueGetter: ({ data }): any => {
            if (!data) {
                return "";
            }
            const rowData = data as any;
            return rowData?.productSchema?.[productSchema.key];
        },
    };

    return colDef;
};
